import * as RouterStoreSelectors from "./selectors";

export * from "./ngrx-router-store.module";

export { RouterStoreSelectors };
